import React, { useEffect, useState } from "react";
import { moonInfo, litPath } from "../../lib/moon";

// A compact, on-brand moon-phase widget for the sidebar. Shows tonight's phase (in the
// viewer's local time), % illuminated, and how many nights until the next full moon.
export function MoonPhaseWidget() {
  const [info, setInfo] = useState(() => moonInfo());

  useEffect(() => {
    const id = setInterval(() => setInfo(moonInfo()), 5 * 60 * 1000); // refresh every 5 min
    return () => clearInterval(id);
  }, []);

  const r = 16;
  const isFull = info.daysToFull === 0 || info.daysToFull >= 29 || info.illumination >= 99;
  const fullLabel = isFull ? "Full moon tonight" : `Full moon in ${info.daysToFull} night${info.daysToFull === 1 ? "" : "s"}`;

  return (
    <div className="mt-1.5 shrink-0 px-3 py-2 rounded-xl bg-gradient-to-br from-slate-900 to-indigo-950/40 border border-slate-800" data-testid="moon-phase-widget" title={`${info.phase} · ${info.illumination}% illuminated`}>
      <div className="flex items-center gap-3">
        <svg width={r * 2} height={r * 2} viewBox={`0 0 ${r * 2} ${r * 2}`} className="shrink-0 drop-shadow-[0_0_6px_rgba(129,140,248,0.35)]" aria-hidden="true">
          <circle cx={r} cy={r} r={r} fill="#0b1120" stroke="#1e293b" strokeWidth="1" />
          <path d={litPath(info.frac, r)} fill="#e6ebf5" />
          <circle cx={r} cy={r} r={r} fill="none" stroke="#334155" strokeWidth="1" />
        </svg>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-slate-100 truncate" data-testid="moon-phase-name">{info.phase}</div>
          <div className="text-[11px] text-indigo-300/90" data-testid="moon-illumination">{info.illumination}% illuminated</div>
        </div>
      </div>
      <div className="mt-1.5 pt-1.5 border-t border-slate-800/70 text-[11px] text-slate-400 [@media(max-height:820px)]:hidden" data-testid="moon-next-full">{fullLabel}</div>
    </div>
  );
}
